import { useEffect } from "react";

const isBrowser = () => typeof window !== "undefined";

// Really simple hook which adds the given class to the document body
export const useBodyClass = (className: string) => {
  useEffect(() => {
    if (isBrowser()) {
      if (className) {
        document.body.classList.add(className);
      }
    }

    return () => {
      if (isBrowser()) {
        if (className) {
          document.body.classList.remove(className);
        }
      }
    };
  }, [className]);
};
